<h4 translate>All PRM Users can access all patient programs, this association is only necessary for non-PRM users.</h4>
<div *ngIf="form" [formGroup]="form">
    <!-- New Facility Portal Person-->
    <div class="btn-plus-new">
        <button
            id="fnd-configuration-new"
            class="btn btn-light btn-flush-left"
            (click)="onShowFacilityPortalPersonGrid()"
            type="button"
            translate
        >
        + New
        </button>
    </div>

    <table class="table emds-table table-sticky-header insurance-table table-striped table-selected-row">
        <thead>
        <tr>
          <th translate>User Name</th>
          <th translate>Full Name</th>
          <th translate>Active</th>
          <th class="column-width" translate>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let formGroupRow of facilityPortalPersonFormArray.controls; index as idx"
            [class.selected]="idx === selectedIndex"
            (click)="choseTableItem(idx)"
        >
          <td>{{formGroupRow.value.UserName}}</td>
          <td>{{formGroupRow.value.FullName}}</td>
          <td>{{formGroupRow.value.PatientWebAccess | yesNoPipe}}</td>
          <td>
            <div class="emds icons-container">
              <a role="button" title="edit" (click)="onEditTableItem($event, formGroupRow.value)">
                <!-- <a role="button" title="edit" (click)="onEditTableItem()"> -->
                <mat-icon class="material-icons edit">edit</mat-icon>
              </a>
              <a role="button" title="delete" (click)="onDeleteTableItem($event, idx)">
                <mat-icon class="material-icons delete">delete</mat-icon>
              </a>
            </div>
          </td>
        </tr>
        </tbody>
    </table>
</div>
